<template>
    <BaseCard>
        <template #image>
            <BaseImage
                sizes="(max-width: 900px) 95vw, 780px"
                :image="{url: event?.image}"
            />
        </template>

        <template #label>
            <p><BaseDate :format-string="'d MMMM'" :iso-date="event?.start_date" /></p>
        </template>

        <template #title>
            <h4>{{ event?.title }}</h4>
        </template>

        <template #info>
            <div>
                <BaseIcon v-if="event.type" :icon="event?.type === 'webinar' ? 'camera' : 'location'" />
                <span v-if="event.type">{{ event?.type === 'webinar' ? ' Webinar' : event?.location }}</span>

                <BaseIcon icon="event" />
                <span><BaseDate :iso-date="event?.start_date" /></span>
            </div>

            <BaseButton
                class="base-button--outline-dark-green"
                :element="defineNuxtLink({})"
                :to="`/events/${event?.slug}`"
            >
                View Event
            </BaseButton>
        </template>
    </BaseCard>
</template>

<script setup>
defineProps({
    event: {
        type: Object,
        default: () => ({})
    }
});
</script>

<style lang="less">

</style>
